import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';

/**
 * Generated class for the MapviewMapview2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-mapview-mapview2',
  templateUrl: 'mapview-mapview2.html',
})
export class MapviewMapview2Page {
  liveTab: string = 'details'
  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MapviewMapview2Page');
  }

}



// WEBPACK FOOTER //
// ./src/pages/mapview-mapview2/mapview-mapview2.ts